import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { POSTULACIONES_LOG_MOCK } from '../mocks/postulaciones-log.mock';
import { RolPlataforma } from '../models/novedades.models';

export interface PostulacionAccionLog {
  timestamp: string;
  rol: RolPlataforma;
  usuario?: string;
  idPostulacion: string;
  folio: string;
  accion:
    | 'crear_postulacion'
    | 'ver_bases'
    | 'acceder_formulario'
    | 'editar_formulario'
    | 'firmar_patrocinio'
    | 'solo_lectura'
    | 'eliminar'
    | 'descargar'
    | 'aceptar_invitacion'
    | 'rechazar_invitacion'
    | 'invitar_colaborador'
    | 'invitar_recomendador'
    | 'solicitar_patrocinio'
    | 'enviar_postulacion'
    | 'guardar_recomendacion'
    | 'enviar_recomendacion'
    | 'editar_recomendacion';
  detalle: string;
}

@Injectable({ providedIn: 'root' })
export class PostulacionesLogService {
  private readonly logsSubject = new BehaviorSubject<PostulacionAccionLog[]>(POSTULACIONES_LOG_MOCK);
  readonly logs$ = this.logsSubject.asObservable();

  registrar(log: PostulacionAccionLog): void {
    this.logsSubject.next([log, ...this.logsSubject.value]);
  }
}
